const SELECT_DATASET = 'SELECT_DATASET';
const CLOSE_DATASET = 'CLOSE_DATASET';
const SELECT_CATEGORY = 'SELECT_CATEGORY';

const initialState = {
	// selectedDataSet: null,
	dataSet: null,
	reducerName: null,
	dataSource: null,
	title: null,
	columns: null,
	tableView: null,
	selectedCategory: 'violation', // default category
};


export const selectDataSet = ({
	dataSet,
	reducerName,
	dataSource,
	title,
	columns,
	tableView = null,
}) => ({
	type: SELECT_DATASET,
	payload: {
		dataSet,
		reducerName,
		dataSource,
		title,
		columns,
		tableView,
	},
});

export const selectCategory = (category) => ({
	type: SELECT_CATEGORY,
	payload: {
		selectedCategory: category
	}
});

export const closeDataSet = () => ({
	type: CLOSE_DATASET,
	payload: {
		dataSet: null,
		reducerName: null,
		dataSource: null,
		title: null,
		columns: null,
		tableView: null,
	}
});

const overviewDataSetReducer = (state = initialState, action) => {
	switch (action.type) {
		case SELECT_DATASET:
		case CLOSE_DATASET:
		case SELECT_CATEGORY:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default overviewDataSetReducer;
